import React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioTower } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

const LABELS = { bluesky: 'Bluesky', mastodon: 'Mastodon', reddit: 'Reddit' };

export const SocialSourceToggles = ({ sources, enabledSources, onToggle }) => {
  const { t } = useTranslation();
  return (
  <div className="grid gap-px overflow-hidden rounded-sm border border-border bg-border md:grid-cols-3" data-testid="social-listening-source-toggles">
    {sources.map((source) => {
      const enabled = enabledSources.includes(source.source);
      const healthy = source.state === 'healthy';
      return (
        <div key={source.source} className="bg-background p-3" data-testid={`social-source-${source.source}`}>
          <div className="flex items-center justify-between gap-3">
            <div className="flex min-w-0 items-center gap-2">
              <RadioTower className={`h-3.5 w-3.5 ${healthy ? 'text-emerald-600' : 'text-muted-foreground'}`} />
              <span className="text-[13.5px] font-semibold">{LABELS[source.source] || source.source}</span>
            </div>
            <Switch
              checked={enabled}
              onCheckedChange={(checked) => onToggle(source.source, checked)}
              aria-label={`Use ${LABELS[source.source] || source.source} signals`}
              data-testid={`social-source-${source.source}-toggle`}
            />
          </div>
          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            <span
              className={`rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase ${healthy ? 'bg-emerald-100 text-emerald-800' : source.configured ? 'bg-amber-100 text-amber-800' : 'bg-secondary text-muted-foreground'}`}
              data-testid={`social-source-${source.source}-status`}
            >
              {source.configured ? source.state : t('social.awaitingSetup')}
            </span>
            <span className="text-[9.5px] text-muted-foreground" data-testid={`social-source-${source.source}-cost`}>{source.cost_note}</span>
          </div>
        </div>
      );
    })}
  </div>
  );
};

export default SocialSourceToggles;